import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Helpers, KeyStorageData, useAppSelector, PasswordResetSteps } from "src/common";
import { Loading, PageHeader, SharedCurrentPasswordForm, PasswordChangedMessage } from "src/components";
import { PasswordForm } from ".";
import { RootState } from "src/store/configureStore";

/* Description: Component for the user to change their password. */
function PasswordResetComponent() {
  const current_account = useAppSelector((state: RootState) => state.account.current_account);
  const auth_token_store = useAppSelector((state: RootState) => state.account.auth_token);
  const [auth_token, setAuthToken] = useState<string>();
  const [step, setStep] = useState<PasswordResetSteps>(PasswordResetSteps.LOADING);

  useEffect(() => {
    if (!!auth_token_store) {
      setAuthToken(auth_token_store);
      setStep(PasswordResetSteps.CHANGE_PASSWORD);
    } else {
      setStep(PasswordResetSteps.SUBMIT_PASSWORD);
    }
  }, []);

  async function handleSubmit(old_password: string): Promise<void> {
    if (!!current_account) {
      const old_auth_token = Helpers.b64Encode(await KeyStorageData.authenticationToken(current_account.user_id, old_password));
      setAuthToken(old_auth_token);
    }
    setStep(PasswordResetSteps.CHANGE_PASSWORD);
  }

  // Description: Render the correct form
  function ResetForms() {
    switch (step) {
      case PasswordResetSteps.SUBMIT_PASSWORD:
        return <SharedCurrentPasswordForm submit={handleSubmit} />;
      case PasswordResetSteps.CHANGE_PASSWORD:
        return (!!current_account && !!auth_token) ?
          <PasswordForm current_account={current_account} auth_token={auth_token}
            handleComplete={(params: { step: PasswordResetSteps, new_auth_token?: string }) => {
              !!params.new_auth_token && setAuthToken(params.new_auth_token);
              setStep(params.step);
            }} /> : <Loading />;
      case PasswordResetSteps.CHANGE_PASSWORD_SUCCESS:
        return <PasswordChangedMessage handleClose={() => setStep(PasswordResetSteps.CHANGE_PASSWORD)} />;
      default:
        return <Loading message="Changing Password" />;
    }
  }

  return <>
    <PageHeader>
      <h1>Change Password</h1>
    </PageHeader>
    <Card className="card-section">
      <ResetForms />
    </Card>
  </>;
}

export default React.memo(PasswordResetComponent);
